<template lang="html">
  <div id="loading-screen"
    class="d-flex justify-content-center align-items-center"
    v-if="!pageReady"
  >
    <!-- Keeley logo -->
    <div class="container">
      <img src="/static/img/blackline-mark.svg" />
      <div class="mt-4 position-relative
      d-flex align-items-center justify-content-center">
        <img class="loading-circle" src="/static/loading-circle.svg">
        <!-- <div class="loading-bar" :style="{'width': percent + '%'}"></div>
        <div class="loading-bar-bg" :style="{'width': '100%'}"></div> -->
        <div v-if="showPercentage && hasScaleModel && deviceMd"
        class="loading-label">{{ percent }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'loading-screen',
  data() {
    return {
      percent: 0,
      showPercentage: false
    };
  },
  computed: {
    ...mapState({
      hasScaleModel: state => state.project.hasScaleModel,
      pageReady: state => state.ui.pageReady
    }),
    ...mapGetters({
      deviceMd: 'ui/deviceMd'
    })
  },
  methods: {
    setLoadingPercent(percent) {
      this.percent = Math.floor(percent);
    }
  },
  created() {
    if (((this.$route.name === 'FloorplanList'
      || this.$route.name === 'FloorplanDetail'
      || this.$route.name === 'FloorplanFavourites') &&
       this.hasScaleModel)
       || this.$route.name === 'Tour') {
      window.setLoadingPercent = this.setLoadingPercent;
      this.showPercentage = true;
    }
  }
};
</script>

<style lang="scss">
#loading-screen {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  bottom: 0;
  background-color: white;
  z-index: 999999999;

  .container {
    width: 200px;
    max-width: 85%;

    img {
      max-width: 100%;
    }
  }

  .loading-circle {
    width: 50px;
  }

  .loading-bar {
    height: 2px;
    background-color: black;
    position: absolute;
    top: 0;
  }

  .loading-bar-bg {
    background-color: #eee;
    height: 2px;
  }

  .loading-label {
    font-family: Scandia-Regular, sans-serif;
    position: absolute;
    top: 17px;
    font-size: 0.8rem;
    color: black;
    width: 50px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingScreen.vue